import {
  observable,
  computed,
  toJS,
  _getGlobalState,
  _isComputingDerivation,
} from 'mobx';

const getGlobalState = _getGlobalState;
const isComputingDerivation = _isComputingDerivation;

// FIXME - Export hack used for tests. Replace with wrapper methods
// eslint-disable-next-line import/no-mutable-exports
export let objectCache = {};

let tid = 0;
function getNextId() {
  // eslint-disable-next-line no-plusplus
  return ++tid;
}

export function getMemoisationID(object, prop = '$tid') {
  let tidMem = object[prop];
  if (tidMem === undefined) {
    tidMem = getNextId();
    object[prop] = tidMem;
  }
  return tidMem;
}

export function resetObjectCache() {
  tid = 0;
  objectCache = {};
}

// eslint-disable-next-line func-names
export const unObserve = function (varObj, keys = null) {
  // unObserve recursively for Input createTransformer
  const newVars = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key of varObj.props) {
    if (keys) {
      if (keys.includes(key)) {
        newVars[key] = varObj[key];
      }
    } else {
      newVars[key] = varObj[key];
    }
  }
  return newVars;
};

// eslint-disable-next-line func-names
export const copy = function (object) {
  return observable.object(toJS(object));
};

export function modelAppTransformer(transformer, cacheContextIdFunc) {
  /* This behaves much like mobx.createTransformer. However, the returned
  transformer, return computedApp on which we need to call .get() to retrieve the App.
   The implmentation could be cleaner if mobx exposed this ComputedValue class */
  const globalState = getGlobalState();
  let { resetId } = globalState;
  return model => {
    if (resetId !== globalState.resetId) {
      objectCache = {};
      ({ resetId } = globalState);
    }
    const memoId = `${cacheContextIdFunc()}-${getMemoisationID(model)}`;

    let computedApp = objectCache[memoId];
    if (computedApp) {
      // console.log('cached: ', model.constructor.name, memoId);
      return computedApp;
    }
    const mappedApp = computed(() => transformer(model));
    if (!isComputingDerivation()) {
      const name = model.constructor?.registryName || model.constructor.name;
      console.warn(
        `You are accessing an AppRef (mapping model to App) for model ${name} - outside a derivation. AppRefs should only be accessed in derivations`,
      );
    }
    computedApp = mappedApp;
    // console.log(model.constructor.name, memoId);
    objectCache[memoId] = mappedApp;
    const { onBecomeUnobserved } = mappedApp;
    // override computedApp.becomeUnobserved to also remove the object from the cache
    // eslint-disable-next-line func-names
    computedApp.onBecomeUnobserved = function () {
      // console.log(`unobserve ${this.constructor.name} -- ${tidMem}`);
      onBecomeUnobserved.apply(mappedApp);
      delete objectCache[memoId];
    };
    return computedApp;
  };
}
